import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { formatDate } from '@atheneum/api/dist/lib'
import Star from '@components/Icon/Star'
import { StatusLabel } from '@components/StatusLabel'

class ProjectsTable extends Component {
  static propTypes = {
    projects: PropTypes.object,
    sidebarStore: PropTypes.object
  }

  render () {
    const { projects } = this.props
    return (
      <table className='table-wrapper contact-projects'>
        <thead>
          <tr>
            <th>Case code</th>
            <th>Project name subindustry</th>
            <th>Project status</th>
            <th>Start date</th>
            <th>End date</th>
            <th>Client office</th>
            <th>Client contact</th>
            <th>Feedback</th>
          </tr>
        </thead>
        {projects.map(project => {
          return (
            <tbody key={project.id}>
              <tr
                className='clickable-row'
                onClick={() =>
                  this.props.sidebarStore.openSidebar({
                    template: 'project',
                    id: project.id
                  })
                }
              >
                <td>
                  <span
                    className={
                      project.caseCode
                        ? 'text-wrapper'
                        : 'text-wrapper casecode'
                    }
                  >
                    {project.caseCode ? project.caseCode : '-'}
                  </span>
                </td>
                <td>
                  <span
                    className='row--link'
                    onClick={e => e.stopPropagation()}
                  >
                    <Link to={`/project/${project.id}`}>
                      {project.projectName}
                    </Link>
                  </span>
                </td>
                <td>
                  <StatusLabel
                    statusId={project.projectStatusId}
                    statusesType='projectStatuses'
                  />
                </td>
                <td>
                  <span className='text-wrapper'>
                    {formatDate(project.startDate)}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {formatDate(project.endDate)}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {project.clients[0].client.office.officeName}
                  </span>
                </td>
                <td>
                  <span
                    className='row--link'
                    onClick={e => e.stopPropagation()}
                  >
                    <Link to={`/client-contact/${project.clients[0].id}`}>
                      {project.clients[0].title} {project.clients[0].fullName}
                    </Link>
                  </span>
                </td>
                <td>
                  {project.clientFeedbacks.length ? (
                    <span className='text-wrapper center'>
                      <Star />
                      {project.clientFeedbacks[0].averageRating}
                    </span>
                  ) : (
                    <span className='text-wrapper center'>-</span>
                  )}
                </td>
              </tr>
            </tbody>
          )
        })}
      </table>
    )
  }
}

export default inject('sidebarStore')(observer(ProjectsTable))
